import { NavLink } from 'react-router-dom';

const tabs = [
  { path: '/home', label: '홈', icon: 'ri-home-5-line', activeIcon: 'ri-home-5-fill' },
  { path: '/vendors', label: '추천업체', icon: 'ri-store-2-line', activeIcon: 'ri-store-2-fill' },
  { path: '/quotes', label: '견적함', icon: 'ri-file-list-3-line', activeIcon: 'ri-file-list-3-fill' },
  { path: '/my', label: '마이', icon: 'ri-user-3-line', activeIcon: 'ri-user-3-fill' },
];

export default function BottomNav() {
  return (
    <nav className="sticky bottom-0 z-50 w-full bg-white border-t border-cream-dark">
      <div className="flex items-center justify-around h-16 pb-[env(safe-area-inset-bottom)]">
        {tabs.map((tab) => (
          <NavLink
            key={tab.path}
            to={tab.path}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center gap-0.5 flex-1 h-full cursor-pointer transition-colors duration-200 ${
                isActive ? 'text-navy' : 'text-beige-dark'
              }`
            }
          >
            {({ isActive }) => (
              <>
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className={`${isActive ? tab.activeIcon : tab.icon} text-xl`} />
                </div>
                <span className="text-[11px] font-medium">{tab.label}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}